import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import track from 'react-tracking';
import layoutWithNavbar from 'layouts/withNavbar';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import './ThankYou.scss';
import BigCheckIcon from 'assets/icons/big-check.svg';
import classNames from 'classnames';
import { getRTL } from 'shared/redux/selectors';
import { saveUserRating } from 'shared/redux/actions';
import { connect } from 'react-redux';
import { RatingStar, BotTyping } from 'components';
// import { PATH } from 'shared/constants';

import { trackCompleteProspect } from './CallToAction.tracking';
import trackEvent from 'components/TrackEvent';
import { eventGetInTouchCompleted } from 'components/TrackEvent/constEvent';

const ThankYou = ({
  intl,
  summary,
  onSaveUserRating,
  rating,
  // CMAClassification,
  isRtl,
  refCode,
  tracking,
  currentLocale
}) => {
  const classes = classNames({
    'thank-you': true,
    'thank-you--rtl': isRtl,
  });

  const selectApplication = () => {
    switch (summary['summary.applicationVia']) {
      case 'email_forms':
        return 'Open Account Later';
      case 'go_to_cob':
        return 'Open Account Now';
      default:
        return 'Open Account';
    }
  }

  const selectCTA = (cta) => {
    switch (cta) {
      case 'meet_advisor':
        return 'Appointment';
      case 'open_account':
        return selectApplication();
      case 'email_product':
        return 'Email Simulation';
      default:
        return '';
    }
  };

  const handleCompletePropect = (star) => {
    const initialInvestment = numeral(summary['summary.initialInvestment']).value();
    const isRetail = initialInvestment >= 5000 && initialInvestment <= 99999;
    const isAffluent = initialInvestment >= 100000 && initialInvestment <= 250000;
    const body = {
      refCode,
      name: summary['summary.name'],
      phone: summary['summary.phone'],
      email: summary['summary.email'],
      age: summary['summary.age'].split(' Year')[0],
      assets: summary['summary.targetAmount'],
      investableAsset: summary['summary.initialInvestment'] || '',
      goal: intl.formatMessage({ id: summary['summary.goal'] }),
      risk: intl.formatMessage({ id: summary['summary.risk'] }),
      // cma: intl.formatMessage({ id: summary['summary.regulatoryClassification'] }, { textQualified: 'no', textRetail: 'no' })
      //   .split(' ')[1]
      //   .split('Investor')[0],
      // eslint-disable-next-line no-nested-ternary
      clientSegment: isRetail ? 'retail' : isAffluent ? 'affluent' : 'private',
      dateTime: `${moment().locale('en').format('DD/MM/YY')}, ${moment().format('HH:mm')}`,
      cta: selectCTA(summary['summary.proceedOption']),
      rating: star,
    };
    trackCompleteProspect(tracking, body);
  };

  return (
    <section className={classes}>
      <h1>{intl.formatMessage({ id: 'thankYou' })}</h1>
      <FormattedMessage id="thankYou.refCode">
        {
            txt => (
              <p className="thank-you__code">
                <span>{txt}</span>
                {refCode ? <strong>{refCode}</strong> : <BotTyping alwaysShow />}
              </p>
            )
          }
      </FormattedMessage>
      <article>
        <img src={BigCheckIcon} alt="Thank you" />
        <p><strong>{intl.formatMessage({ id: 'thankYou.dearUser' }, { user: summary && summary['summary.name'] })}</strong></p>

        {summary['summary.proceedOption'] !== 'open_account' && (
          <p>{intl.formatMessage({ id: `thankYou.${summary['summary.proceedOption']}` })}</p>
        )}

        {summary['summary.proceedOption'] === 'open_account' && (
          <>
            {summary.hasOwnProperty('summary.applicationVia') && summary['summary.applicationVia'] === 'go_to_cob' ? (
              <>
                <p><FormattedHTMLMessage id="thankYou.open_account" values={{ link: `${process.env.REACT_APP_COB_URL}/login?refCode=${refCode}` }} /></p>
                <p>{intl.formatMessage({ id: 'thankYou.open_account2' })}</p>
              </>
            ) : (
              <p><FormattedHTMLMessage id="thankYou.open_account_email" values={{ link: `${process.env.REACT_APP_COB_URL}/login?refCode=${refCode}` }} /></p>
            )}
          </>
        )}
        
        <p><small>{intl.formatMessage({ id: 'thankYou.notes' })}</small></p>
      </article>

      <p><FormattedMessage id="thankYou.howYouRate" /></p>
      <RatingStar
        onSaveUserRating={(value) => {
          onSaveUserRating(value);
          if (refCode) {
            handleCompletePropect(value);
          }
          /** */
          // trackUserExperience(tracking, value);
          /** */
          trackEvent(eventGetInTouchCompleted(currentLocale, summary ? summary['summary.email'] : ''));
        }}
        rating={rating}
      />
    </section>
  );
};

const mapStateToProps = state => ({
  summary: state.rootReducer.summary,
  rating: state.rootReducer.userInfo.rating,
  isRtl: getRTL(state.rootReducer),
  refCode: state.ctaReducer.referenceCode,
  CMAClassification: state.rootReducer.CMAClassification,
  currentLocale: state.rootReducer.language.locale
});

const mapDispatchToProps = ({
  onSaveUserRating: saveUserRating,
});

export default track({
  page: 'ThankYou',
})(
  connect(mapStateToProps, mapDispatchToProps)(layoutWithNavbar(injectIntl(ThankYou))),
);
